import styled from 'styled-components';

import { mediaTopBarVisible } from '@xing-com/layout-tokens';
import type { LinkProps } from '@xing-com/link';
import { Link as CrateLink } from '@xing-com/link';
import {
  cornerRadiusXL,
  scale010,
  scale020,
  scale030,
  scale040,
  spaceS,
  xdlColorFocusRing,
  xdlColorHover,
  xdlColorHoverSecondary,
  xdlColorText,
} from '@xing-com/tokens';

export const Link = styled(CrateLink)<LinkProps>`
  color: ${xdlColorText};
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  border-radius: ${cornerRadiusXL};
  padding: ${spaceS};

  /* stylelint-disable-next-line media-query-no-invalid */
  @media ${mediaTopBarVisible} {
    border-radius: 0;
    padding: ${scale040} ${scale040} ${scale020};
    margin-bottom: ${scale030};
  }

  &:hover,
  &:active {
    text-decoration: none;
    background-color: ${xdlColorHoverSecondary};

    /* stylelint-disable-next-line media-query-no-invalid */
    @media ${mediaTopBarVisible} {
      background-color: ${xdlColorHover};
    }

    @media (prefers-contrast: more) {
      outline: ${scale010} solid ${xdlColorFocusRing};
    }
  }

  &:focus {
    text-decoration: none;
    outline: ${scale010} solid ${xdlColorFocusRing};
  }
`;
